import React, { useState } from "react";
import { TOAST_CLASSES, UNPUBLISHED_TXT } from "../../../utils/constants";
import { useSolution } from "../../../contexts/SolutionsContext";
import { Input } from "antd";
import CustomButton from "../../Atoms/Buttons/CustomButton";
import "../css/rejection.reason.sol.css";

const ReasonForRejectionSol = ({
  setEnableReasonBoxSol,
  solutionId,
  clearSolutionDrawerData,
}) => {
  const { publishSolution, isApprovingRejecting, showToastMessage } =
    useSolution();

  const [rejectionReason, setRejectionReason] = useState("");

  const handleUnpublishSolution = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!solutionId) {
      showToastMessage("Solution ID is not available.", TOAST_CLASSES?.ERROR);
      return;
    }

    await publishSolution(solutionId, UNPUBLISHED_TXT, rejectionReason);
    setEnableReasonBoxSol(false);

    await clearSolutionDrawerData();
  };
  return (
    <>
      <div
        className="rejection-sol-info-container"
        style={{ marginTop: "32px" }}
      >
        <div className="row">
          <div className="col-md-12">
            <label className="rejection-sol-info-title mb-3">
              Reason for Rejection
            </label>
            <span className="marketplace-req-asterik">*</span>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="rejection-sol-details">
              <div className="rejection-sol-detail-row mb-3">
                <div className="col-md-12">
                  <Input
                    type="text"
                    placeholder="Type Reason for Rejection"
                    className="custom-input-size"
                    value={rejectionReason}
                    onChange={(e) => setRejectionReason(e?.target?.value)}
                    disabled={isApprovingRejecting}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end gap-2">
          <CustomButton
            label="Cancel"
            onClickFn={() => setEnableReasonBoxSol(false)}
            clsNames={"mas-btn-med mas-secondary-btn"}
            disabled={isApprovingRejecting}
          />
          <CustomButton
            label="Submit"
            onClickFn={(e) => handleUnpublishSolution(e, solutionId)}
            clsNames={"mas-btn-med mas-primary-btn"}
            disabled={isApprovingRejecting || rejectionReason === "" || !rejectionReason}
          />
        </div>
      </div>
    </>
  );
};

export default ReasonForRejectionSol;
